<!-- Qty -->
<div class="text-left" style="position: relative;">
    <div class="d-flex justify-content-between">
        <!-- Button minus -->
        <button class="btn-circle btn-primary btn-xs" type="button" style="padding-top: 6px" [disabled]="productQuantity <= 0" 
            (click)="changeQuantity(false)">
            <i class="fa fa-minus"></i>
        </button>
        <!-- Quantity -->
        <span class="p-l-20 p-r-20 font-h6">{{productQuantity}}</span>
        <!-- Button plus -->
        <!-- Valida disable por cantidad maxima del ticket -->
        <!-- eventIsGeneric || (!eventIsGeneric && !model.isGeneric)  -->
        <ng-container *ngIf="eventType == 1 || eventType == 2"><!-- events -->
            <button *ngIf="eventStock > 0" class="btn-circle btn-primary btn-xs" 
                type="button" style="padding-top: 6px" 
                [disabled]="(allSelected * quantityOfPlaces  >= availableQuantity || allSelected * quantityOfPlaces  >= availableQuantityByEvent 
                || quantityOfPlaces > availableQuantity || quantityOfPlaces > availableQuantityByEvent) && ticketStock > 0 || 
                (purchaseLimit > 0 && singleTicketSelected >= purchaseLimit)"
                    (click)="changeQuantity(true)">
                    <i class="fa fa-plus"></i>
                </button>
                <!-- Valida disable por cantidad maxima del evento -->
                <!-- !eventIsGeneric && model.isGeneric -->
                <button *ngIf="eventStock <= 0" class="btn-circle btn-primary btn-xs" 
                type="button" style="padding-top: 6px" [disabled]="(productQuantity * quantityOfPlaces >= availableQuantity || quantityOfPlaces > availableQuantity) && ticketStock > 0
                || (purchaseLimit > 0 && singleTicketSelected >= purchaseLimit)"
                    (click)="changeQuantity(true)">
                    <i class="fa fa-plus"></i>
                </button>
        </ng-container> 
        <ng-container *ngIf="eventType != 1 && eventType != 2"><!-- passes, cashless -->
            <button class="btn-circle btn-primary btn-xs" 
                type="button" style="padding-top: 6px" 
                [disabled]="(productQuantity * quantityOfPlaces >= availableQuantity && ticketStock > 0) || isError || (purchaseLimit > 0 && singleTicketSelected >= purchaseLimit)"
                    (click)="changeQuantity(true)">
                    <i class="fa fa-plus"></i>
                </button>
        </ng-container>
    </div>
    <small class="m-t-20 text-danger" *ngIf="showError(2)">Últimos cupos de esta entrada</small>
    <small class="m-t-20 text-danger" *ngIf="showError(1)">Has alcanzado el límite <br> permitido por persona</small>

    <!--
    <div [ngClass]="{'close': validCloseAlert, 'd-flex alert-max-quantity' : validShowAlert}">
        <div>
            <small>Cantidad maxima de tickets</small>
        </div>
        <div (click)="closeAlert()" class="m-l-15 cursor-pointer">
            <small class="m-r-10 font-bold">X</small>
        </div>
    </div>
    -->
</div>